import React, { useState } from 'react';

import { timingBridgeAPI } from '../../../lib/api';

const BUTTON = 'px-3 py-1.5 text-xs rounded border border-[#2a2a2a] bg-[#0a0a0a] text-gray-300 hover:border-[#3a3a3a] disabled:opacity-40';

/**
 * The read-only broadcast timing page: open it here, or copy the no-login link
 * for commentators. Neither can change anything the graphics show.
 */
export default function BroadcastLinks({ showId }) {
  const [link, setLink] = useState('');
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');

  async function copyLink(regenerate = false) {
    setBusy(true);
    setError('');
    try {
      const res = await timingBridgeAPI.viewLink(showId, regenerate);
      const url = `${window.location.origin}${res.data.path}`;
      setLink(url);
      await navigator.clipboard?.writeText(url).catch(() => {});
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not make the link');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="px-4 py-3 bg-[#111111] border border-[#2a2a2a] rounded space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="text-sm font-semibold text-white mr-auto">Broadcast page</h2>
        <a href={`/broadcast/timing/${showId}`} target="_blank" rel="noreferrer" className={BUTTON}>Open</a>
        <button onClick={() => copyLink(false)} disabled={busy} className={BUTTON}>{copied ? 'Copied' : 'Copy commentator link'}</button>
        {link && (
          <button
            onClick={() => { if (window.confirm('Make a new link? The old one stops working for anyone who has it.')) copyLink(true); }}
            disabled={busy}
            className="text-[11px] text-gray-500 hover:text-gray-300"
          >
            New link
          </button>
        )}
      </div>
      {link && <code className="block text-[11px] text-gray-400 truncate" title={link}>{link}</code>}
      {error && <div className="text-xs text-red-400">{error}</div>}
      <p className="text-[10px] text-gray-600 leading-relaxed">
        Live timing, battles worth following, and the championships as if the race ended now, with the round standings and who can
        still win. For the team and commentators only: it reads the timing and never changes a data stream or a graphic. The link
        needs no login; "New link" revokes the old one.
      </p>
    </section>
  );
}
